import * as React from 'react';
import { useState,useRef,useEffect } from 'react';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Header from '../components/header';
import { Formik, Form, Field,ErrorMessage} from 'formik';
import InputAdornment from '@mui/material/InputAdornment';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { MuiTextFieldFormik, MuiTelInputFormik } from '../../../components/CustomTextField/TextField';
import { toContactDigits, validateRegisterationForm } from '../../../common/utility/validators';
import { useAxios } from '../../../common/api/hooks/useAxios';
import api from '../../../common/api/axios';
import { URL } from '../../../common/api/urls';
import { useNavigate, useLocation } from 'react-router-dom';
import WelcomeLayout from '../components/welcome-layout';
import FormContainer from '../components/form-container';
import { useTheme } from '@mui/material';
import MainLayoutContainer from '../components/main-layout';
import { TEXT_MSGS } from '../../../common/utility/constant';
import AppErrorPopup from '../../../components/AppErrorPopup';
import TermsOfUseModal from '../../dashboard/components/terms_of_use';
import MobileOtpVerificationDialog from './MobileOtpVerificationDialog';
// import bannerImg from '../../../assets/images/diwali-frontpage-banner.jpeg';
import bannerImg from '../../../assets/images/hny-frontpage-banner1.jpeg';
import miniBannerImg from '../../../assets/images/mini-banner1.jpeg';


const initialValues = {
  first_name:'',
  last_name:'',
  email_id: '',
  password: '',
  contact:'',
  terms: false
};

export default function RegisterUser() {
  const theme=useTheme();
  const [showPassword, setShowPassword] = useState(false);
  const {
    cancel: googleCancel, 
    responseData: googleResponseData, 
    error: googleError, 
    loaded: googleLoaded, 
    reset: googleReset, 
    executeAPI: googleExecuteAPI
  } = useAxios()
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const formikRef = useRef();
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [pendingRegistration, setPendingRegistration] = useState(null);
  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });

 const { open, msg,severity } = msgState;

 const handleClickShowPassword = () => setShowPassword(!showPassword);
 
 const [apiError,setAPIError]=useState(undefined);
  
/**
 * Google OAuth response handler  
 */  
    useEffect(()=>{
      if(googleLoaded){
        if(googleResponseData != null){
          const url = googleResponseData.auth_url
          window.location.href = url
        }else if(googleError !== null){
          setMsgState({open:true,msg:googleError?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          googleReset();
        }
      }
    },[googleResponseData])
  
 /**
 * API caller  
 */  
  const onSubmit = async (values, { setSubmitting }) => {
    setAPIError(undefined);
    const digits = toContactDigits(values.contact);
    setPendingRegistration({
      first_name: values.first_name,
      last_name: values.last_name,
      email_id: values.email_id,
      password: values.password,
      contact: digits,
    });
    try {
      await api.post(URL.SEND_MOBILE_VERIFY_OTP, { contact: digits });
      setSubmitting(false);
      setOtpDialogOpen(true);
    } catch (error) {
      setPendingRegistration(null);
      setSubmitting(false);
      setMsgState({
        open: true,
        msg: error?.response?.data?.message ?? TEXT_MSGS.NETWORK_ERROR_MSG,
        severity: 'error',
      });
    }
  };

  const handleRegisterSuccess = (emailId) => {
    setOtpDialogOpen(false);
    setPendingRegistration(null);
    formikRef.current?.setSubmitting(false);
    navigate(`/email-verification?emailId=${emailId}`, { replace: true });
  };

    const onGoogleSubmit = () => {
       googleExecuteAPI(URL.GOOGLE_URL,"GET", {}); 
    }

 /**
 * autoclosing of the snackbar msg bar 
 */ 
    const handleClose = (event, reason) => {
      setMsgState({...msgState,open:false});
  };

  const [openModal,setOpenModal]=useState(false)
  const openTermModal=()=>{
    setOpenModal(true);
  }

  const closeModal=()=>{
    setOpenModal(false);
  }

  return (
        <MainLayoutContainer>

        {/* Header component */}
        <Header showLogin={true} showIntro={true} showBoth={false}/>
       
        {/*Welcome banner left component*/}
        <WelcomeLayout/>

        {openModal?
            <TermsOfUseModal closeModal={closeModal}></TermsOfUseModal>
              : 
        <></>}

        {/* Form container for right layut */}
        <FormContainer>
          {/* <img src={bannerImg} alt="diwali_offer" style={{width: "100%", marginLeft: 0, marginRight: 40, marginTop: -20, marginBottom: 120}} /><br/> */}
          {/* <img src={miniBannerImg} alt="diwali_offer" style={{width: "100%", marginLeft: 0, marginRight: 40, marginTop: -20, marginBottom: 20}} /><br/> */}
       
        <Box sx={{mt:{mobile:0,tablet:0}, width:{mobile:"95%", tablet:"85%", laptop:"75%"} }}>
        <Typography  variant="titleMedium">
          Register for Vtrender<sup>™</sup> Charts
        </Typography>
        <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={onSubmit} validate={validateRegisterationForm}>
              {({values, submitForm, resetForm, isSubmitting, touched, errors}) => (
                <Form>
                 
          
                  <Box display="flex" >
                  <Grid container spacing={2} sx={{mt:1,mb:2}}>
                  <Grid item mobile={12} tablet={6}>
                     <Field
                      component={MuiTextFieldFormik}
                      fullWidth
                      required
                      variant="outlined" 
                      size="small" 
                      color="inputFieldColor"
                      id="first_name"
                      name="first_name"
                      type="text"
                      label="First Name"
                    />
                    </Grid>
                     <Grid item mobile={12} tablet={6}>
                    <Field
                      component={MuiTextFieldFormik}
                      fullWidth
                      required
                      variant="outlined" 
                      size="small" 
                      color="inputFieldColor"
                      name="last_name"
                      id="last_name"
                      type="text"
                      label="Last Name"
                    />
                    </Grid>
                    </Grid>
              </Box>

              <Grid container spacing={2} mb={0}>
              <Grid item mobile={12} tablet={6}>
                  
                          <Field
                      component={MuiTextFieldFormik}
                      fullWidth
                      variant="outlined" 
                      size="small" 
                      color="inputFieldColor"
                      id="email_id"
                      name="email_id"
                      type="email"
                      label="Email"
                      required
                    />
                  </Grid> 

                   <Grid item mobile={12} tablet={6}>
               
                    <Field
                      component={MuiTelInputFormik}
                      fullWidth
                      required
                      variant="outlined"
                      size="small"
                      color="inputFieldColor"
                      name="contact"
                      id="contact"
                      label="Mobile No."
                    />
                    </Grid>
              </Grid>

              <Grid container spacing={2} mb={3}>
                <Grid item mobile={12}>
                  <Field
                    component={MuiTextFieldFormik}
                    fullWidth
                    variant="outlined"
                    size="small"
                    color="inputFieldColor"
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    name="password"
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
              </Grid>

              <Typography variant="link">
                <i>Note: Vtrender Charts provides exchange-connected market data. To meet NSE and BSE compliance requirements, every user must register using a valid Email account and Mobile number. Email is verified through an activation email link and Mobile number is verified through WhatsApp OTP.</i>
              </Typography>

              <Grid container mb={0} mt={2}>
                <Grid item mobile={12} alignItems="center">
                <Field as={FormControlLabel}
                    name='terms'
                    control={<Checkbox 
                      sx={{
                        color: theme.palette.secondaryTheme.shade03,
                        '&.Mui-checked': {
                          color:theme.palette.secondaryTheme.shade03,
                        },
                      }}/>
                    }
                    label={<Typography variant="linkSupportText" >
                        I agree to all
                        <Link onClick={openTermModal} sx={{ml:1,cursor:"pointer"}} variant="link">Terms & Conditions, Fees & Privacy Policy</Link>
                      </Typography>
                    }
                   />
                </Grid>
              </Grid>
              
               {/* Error msg incase terms and conditions checkbox is not checked */}
              <ErrorMessage name="terms" render={msg =>  <Typography variant="warningText">{msg}</Typography> } /> 
              
              {apiError!=undefined?
                <Typography variant="errorText">{apiError}</Typography>:
                <></>
              }

              <Grid container>
                <Grid item mobile={12}>
                <Button type='submit'  sx={{mb:2,mr:1, mt:1}} variant="contained" disabled={isSubmitting}
                      fullWidth>{isSubmitting ? "Loading" : "Verify Mobile Number and Register"}</Button>
                </Grid>
              </Grid>

          </Form>
          )}
        </Formik>
                
          <Grid item>
            <Typography variant="link">{"Already have an account? "} 
              <Link href="/login" variant="link" sx={{pb:6}}>
              Log in
              </Link>
            </Typography>
          </Grid>
          <br/><br/>
              <hr/>
              <br/>
              <br/>

              <Button
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mb: 2,
                      backgroundColor: 'white',
                      borderColor: '#dadce0',
                      color: '#3c4043',
                      textTransform: 'none',
                      py: 1.2,
                      '&:hover': {
                        backgroundColor: '#f8f9fa',
                        borderColor: '#dadce0',
                      }
                    }}
                    onClick={onGoogleSubmit}
                    startIcon={
                      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                          <path d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7955 2.7164v2.2581h2.9087c1.7023-1.5668 2.6832-3.8741 2.6832-6.615z" fill="#4285F4"/>
                          <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.482 18 9 18z" fill="#34A853"/>
                          <path d="M3.9636 10.71c-.18-.54-.2822-1.1173-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.348 2.8268.957 4.0418l3.0063-2.3318z" fill="#FBBC05"/>
                          <path d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.3459l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.482 0 2.4382 2.0168.9573 4.9582L3.9636 7.29C4.6714 5.1627 6.6556 3.5795 9 3.5795z" fill="#EA4335"/>
                        </g>
                      </svg>
                    }
                  >
                    Sign up with Google
              </Button>
        </Box>
      
      </FormContainer>

      {pendingRegistration && (
        <MobileOtpVerificationDialog
          open={otpDialogOpen}
          contact={pendingRegistration.contact}
          displayContact={pendingRegistration.contact}
          registrationPayload={pendingRegistration}
          initialOtpSent
          dismissible={false}
          onRegisterSuccess={handleRegisterSuccess}
        />
      )}
      
      <AppErrorPopup
        open={open}
        message={msg}
        severity={severity}
        onClose={handleClose}
        showCloseX
      />
      {/* Legacy snackbar (replaced by AppErrorPopup)
      <Snackbar
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
      >
        <Alert severity={severity} sx={{ width: { mobile: '80%', tablet: '70%', laptop: '40%' } }}>
          {msg}
        </Alert>  
      </Snackbar>     
      */}
    
   </MainLayoutContainer>
  );
}